import {
  IRoleWithPermissionsFieldsFragment,
  IUserPermissionFieldsFragment,
} from '../../../utils/apollo/graphqlSchema';
import { MaybeNil } from '../../../utils/interfaces';

export enum DevPermission {
  /**
   * using permissions received from Kobol
   */
  Default = 'DEFAULT',
  /**
   * force enable all permissions, but mutation/query will still check for permission
   */
  ForceEnable = 'FORCE_ENABLE',
  /**
   * force disable all permission.
   */
  ForceDisable = 'FORCE_DISABLE',
}

export interface IPermission {
  devPermission: DevPermission;
  roles: IRoleWithPermissionsFieldsFragment[];
  user: MaybeNil<IUserPermissionFieldsFragment>;
}
